var map = {
	"./argos.jpg": 112,
	"./argos.png": 56,
	"./cut.png": 113,
	"./detail.png": 114,
	"./flowers.jpg": 115,
	"./flowers.png": 57,
	"./frames.png": 116,
	"./frameshop_1.jpg": 66,
	"./frameshop_2.jpg": 67,
	"./frameshop_3.jpg": 68,
	"./frameshop_4.jpg": 69,
	"./frameshop_5.jpg": 70,
	"./joint.png": 78,
	"./kurt.jpg": 117,
	"./kurt.png": 58,
	"./masons.jpg": 118,
	"./masons.png": 59,
	"./medals.jpg": 119,
	"./medals.png": 60,
	"./necklace.jpg": 120,
	"./necklace.png": 62,
	"./oil.jpg": 121,
	"./oil.png": 63,
	"./owl.jpg": 122,
	"./owl.png": 64,
	"./saw.png": 123,
	"./soldier.jpg": 124,
	"./soldier.png": 61,
	"./spoon.jpg": 125,
	"./spoon.png": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;